export const SKILLS = [
    {
        title: 'Algorithms',
        skillicon: "https://icongr.am/devicon",
    }
];

export const hrProfileApiUrl = "https://www.hackerrank.com/rest/contests/master/hackers";
export const hrBadgesApiUrl = "https://www.hackerrank.com/rest/hackers/abhi_mishra_1/badges";
export const hrScoresApiUrl = "https://www.hackerrank.com/rest/hackers/abhi_mishra_1/scores_elo";
export const hrEducationInfoApiUrl = "https://www.hackerrank.com/community/v1/hackers/abhi_mishra_1/hacker_schools";
export const hrCertificateApiUrl = "https://www.hackerrank.com/community/v1/test_results/hacker_certificate?username=abhi_mishra_1";
export const hrRatingHistoryApiUrl = "https://www.hackerrank.com/rest/hackers/abhi_mishra_1/rating_histories_elo";
export const hrContestHistoryApiUrl = "https://www.hackerrank.com/rest/hackers/abhi_mishra_1/contest_participation?offset=0&limit=5";

export const defaultUser = {
    githubUsername: "abhinandanmishra1",
    codeforcesUsername: "abhinandan_mishra_1",
    hackerrankUsername: "abhi_mishra_1",
    leetcodeUsername: "abhinandan_mishra_1",
    codechefUsername: "abhimishra1",
    username: "abhinandanmishra1",
};
